/**
 * 判断当前是否为移动设备
 * 返回：true为移动设备 false不是移动设备
 * @returns {boolean}
 */
export function isMobileDevice () {
  let ConcertUtilBrowser = {
    versions: (function () {
      let u = navigator.userAgent;
      return { // 移动终端浏览器版本信息
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或uc浏览器
        iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1 // 是否iPad
      };
    })()
  };
  if (((ConcertUtilBrowser.versions.ios && !ConcertUtilBrowser.versions.iPad) || ConcertUtilBrowser.versions.android)) {
    return true;
  } else {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/common/scripts/isMobile.js